import tw, { styled } from "twin.macro";

export const ModalTitle = styled.h1`
	${tw`text-center font-semibold text-lg pb-4`}
`;

export const ModalContainer = styled.div`
	${tw`p-3 sm:p-1.5`}

	input {
		${tw`text-appTextDark border-solid mb-4 px-3 py-3 placeholder-appGentleGray h-14! w-14! mr-5! sm:px-1! sm:py-1! text-appTextDark 
    relative border border-transparent focus:outline-none! focus:ring-2! focus:ring-appPink!
    rounded-xl text-base shadow! text-center flex flex-row items-center justify-center`}
		border: 1px solid #dedef0 !important;
		-webkit-appearance: none;

		@media (max-width: 376px) {
			margin-right: 12px !important;
			max-width: 3rem !important;
			max-height: 3rem !important;
		}
	}
`;
